import { render, staticRenderFns } from "./MobileStickyCart.vue?vue&type=template&id=335eabf6&"
import script from "./MobileStickyCart.vue?vue&type=script&lang=js&"
export * from "./MobileStickyCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335eabf6')) {
      api.createRecord('335eabf6', component.options)
    } else {
      api.reload('335eabf6', component.options)
    }
    module.hot.accept("./MobileStickyCart.vue?vue&type=template&id=335eabf6&", function () {
      api.rerender('335eabf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/MobileStickyCart.vue"
export default component.exports